<template>
  <AbaFiltro v-if="!loading" :titulo="titulo">
    <unicom-campo-calendario-v3
      fecharClique
      regrasValidacao="required|validacaoMes"
      :duploClique="false"
      v-model="objetoFiltro.competencia"
      placeHolder="Competência"
      mostrarIconeExcluir
      :componentesAtivos="['Meses', 'Anos']"
    />
    <template slot="botao">
      <unicom-botao
        :desabilitado="!habilitado"
        @click="proximaAba"
        :largura="360"
        :altura="40"
      >
        CONTINUAR
      </unicom-botao>
    </template>
  </AbaFiltro>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaFiltroMixin from "../AbaFiltroMixin";

export default {
  mixins: [AbasMixin, AbaFiltroMixin]
};
</script>
